var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFailureIconForModal = function SvgFailureIconForModal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    x: 1,
    y: 1,
    fill: "#FD3838",
    fillOpacity: 0.2,
    rx: 31
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    x: 1,
    y: 1,
    stroke: "#FD3838",
    strokeWidth: 2,
    rx: 31
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FD3838",
    fillRule: "evenodd",
    d: "M28.897 19.75c1.38-2.333 4.827-2.333 6.206 0l12.412 21c1.379 2.333-.345 5.25-3.103 5.25H19.588c-2.758 0-4.482-2.917-3.103-5.25zM32 23.833c.99 0 1.791.784 1.791 1.75v7c0 .967-.802 1.75-1.791 1.75-.99 0-1.791-.783-1.791-1.75v-7c0-.966.802-1.75 1.791-1.75M32 42.5c1.32 0 2.389-1.045 2.389-2.333s-1.07-2.334-2.389-2.334c-1.32 0-2.389 1.045-2.389 2.334 0 1.288 1.07 2.333 2.389 2.333",
    clipRule: "evenodd"
  })));
};
export { SvgFailureIconForModal as ReactComponent };
export default __webpack_public_path__ + "b5049820b73741f457fa38af360f902a.svg";